// Author: Ashutosh Rao Chawan U
// importing the createBrowserHistory from history so that we can redirect the user programmatically.

import { createBrowserHistory } from "history";

export default createBrowserHistory();
